import { Either, LeftSide, RightSide } from "src/base/Either";
import { Failure } from "src/base/Failure";
import {
  IComnetMaterial,
  IMedicalRecordComnetMaterial,
} from "../../domain/model/comnetMaterial";
import { IComnetRemoteDataSource } from "../datasources/comnetRemoteDataSource";

export interface IComnetRepository {
  getMaterials(): Promise<Either<Failure, IComnetMaterial[]>>;
  getMedicalRecordMaterials(medicalRecordId: string): Promise<Either<Failure, IMedicalRecordComnetMaterial[]>>;
  addMedicalRecordMaterial(
    medicalRecordId: string,
    comnetClinicMaterialId: number,
    isShared: boolean,
    comment: string
  ): Promise<Either<Failure, { id: number }>>;
  updateMedicalRecordMaterial(id: number, isShared: boolean, comment: string): Promise<Either<Failure, void>>;
  removeMedicalRecordMaterial(id: number): Promise<Either<Failure, void>>;
}

export class ComnetRepository implements IComnetRepository {
  comnetRemoteDataSource: IComnetRemoteDataSource;
  constructor(remoteDataSource: IComnetRemoteDataSource) {
    this.comnetRemoteDataSource = remoteDataSource;
  }

  async getMaterials(): Promise<Either<Failure, IComnetMaterial[]>> {
    try {
      return RightSide(await this.comnetRemoteDataSource.getMaterials());
    } catch (e) {
      if (typeof e === "string") {
        return LeftSide({ message: e });
      } else if (e instanceof Error) {
        return LeftSide({ message: e.message });
      }
    }
    return LeftSide(new Error(""));
  }

  async getMedicalRecordMaterials(
    medicalRecordId: string
  ): Promise<Either<Failure, IMedicalRecordComnetMaterial[]>> {
    try {
      return RightSide(await this.comnetRemoteDataSource.getMedicalRecordMaterials(medicalRecordId));
    } catch (e) {
      if (typeof e === "string") {
        return LeftSide({ message: e });
      } else if (e instanceof Error) {
        return LeftSide({ message: e.message });
      }
    }
    return LeftSide(new Error(""));
  }

  async addMedicalRecordMaterial(
    medicalRecordId: string,
    comnetClinicMaterialId: number,
    isShared: boolean,
    comment: string
  ): Promise<Either<Failure, { id: number }>> {
    try {
      return RightSide(
        await this.comnetRemoteDataSource.addMedicalRecordMaterial(
          medicalRecordId,
          comnetClinicMaterialId,
          isShared,
          comment
        )
      );
    } catch (e) {
      if (typeof e === "string") {
        return LeftSide({ message: e });
      } else if (e instanceof Error) {
        return LeftSide({ message: e.message });
      }
    }
    return LeftSide(new Error(""));
  }

  async updateMedicalRecordMaterial(
    id: number,
    isShared: boolean,
    comment: string
  ): Promise<Either<Failure, void>> {
    try {
      return RightSide(await this.comnetRemoteDataSource.updateMedicalRecordMaterial(id, isShared, comment));
    } catch (e) {
      if (typeof e === "string") {
        return LeftSide({ message: e });
      } else if (e instanceof Error) {
        return LeftSide({ message: e.message });
      }
    }
    return LeftSide(new Error(""));
  }

  async removeMedicalRecordMaterial(id: number): Promise<Either<Failure, void>> {
    try {
      return RightSide(await this.comnetRemoteDataSource.removeMedicalRecordMaterial(id));
    } catch (e) {
      if (typeof e === "string") {
        return LeftSide({ message: e });
      } else if (e instanceof Error) {
        return LeftSide({ message: e.message });
      }
    }
    return LeftSide(new Error(""));
  }
}
